import {
  faFileInvoice,
  faMoneyBillTransfer,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PaymentAccounts from "../../Payment/PaymentAccounts";
import AqeedahDueForm from "./AqeedahDueForm";

const AqeedahDue = () => {
  return (
    <div className="min-h-screen container mx-auto my-10 px-5">
      <p className="text-center text-2xl">কোর্স ফী/বকেয়া পরিশোধ করুন!</p>
      <div className="mx-auto my-5 text-center ">
        <ul className="steps steps-vertical">
          <li className="step step-primary">
            <a href="#send-money">টাকা পাঠান</a>
          </li>
          <li className="step step-primary">
            <a href="#form">ফর্ম পূরণ করুন</a>
          </li>
        </ul>
      </div>

      <section className="mb-10" id="send-money">
        <div>
          <h2 className="text-2xl text-green-600">
            <FontAwesomeIcon className="pr-5" icon={faMoneyBillTransfer} />
            কিভাবে টাকা পাঠাবেন?
          </h2>
          <p className=" mt-3">
            নিচের যে কোন নাম্বারে টাকা পাঠান (
            <span className="text-red-500 font-bold"> Send Money </span>)
          </p>
          <p className="">
            <FontAwesomeIcon
              className="text-slate-500 me-1"
              icon={"fa-solid fa-copy"}
            />{" "}
            একাউন্ট নাম্বার কপি করতে নাম্বারের উপর ক্লিক করুন।
          </p>
          <p className="">
            <strong className="text-red-600">দোকান থেকে টাকা না পাঠিয়ে </strong>{" "}
            নিজের/বাড়ির কারো নাম্বার থেকে পাঠান, তাহলে টাকাটা গেল কিনা, ঠিক
            নাম্বারে গেল কিনা নিশ্চিত হতে পারবেন।
          </p>
          <p className="mt-1 mb-5">
            <FontAwesomeIcon className="text-blue-500" icon={"image"} /> সম্ভব
            হলে টাকা পাঠানোর পর{" "}
            <strong className="text-blue-600">
              স্ক্রিনশট/মানি রিসিটের ছবি
            </strong>{" "}
            তুলুন।{" "}
          </p>

          <PaymentAccounts />
        </div>
      </section>

      <section className="mb-10" id="form">
        <div>
          <h2 className="text-2xl text-green-600">
            <FontAwesomeIcon className="pr-5" icon={faFileInvoice} />
            ফর্ম পূরণ করুন
          </h2>
          <div className=" ">
            <div className="">
              <p className="mt-3">টাকা পাঠানো হয়ে গেলে ফর্ম পূরণ করুন।</p>
              <p className="mb-3">
                <FontAwesomeIcon className="text-blue-500" icon={"image"} />{" "}
                সম্ভব হলে টাকা পাঠানোর{" "}
                <strong className="text-blue-600">
                  স্ক্রিনশট/মানি রিসিটের ছবি
                </strong>{" "}
                এডমিনকে ইনবক্সে পাঠান।{" "}
              </p>
              {/* <p className='mb-3'>আপনি চাইলে টাকা পাঠানোর পর স্ক্রিনশট/মেসেজ ফর্মে যুক্ত করে দিতে পারেন অথবা এডমিনকে ইনবক্সে দিতে পারেন। </p> */}

              {/* <a
                className="btn btn-success rounded py-1 px-3"
                href="https://docs.google.com/forms/d/e/1FAIpQLSd-JNO4jrMPEzp5MWM9OB9hYRiP4baO53h2Q6pmLlK1Itsgfw/viewform?usp=sf_link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon className="pr-3" icon="fa-solid fa-link" />
                পেমেন্ট ক্লিয়ারেন্স ফর্ম
              </a> */}
              <AqeedahDueForm />
            </div>

            {/* <div className="mx-auto text-center my-5">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSd-JNO4jrMPEzp5MWM9OB9hYRiP4baO53h2Q6pmLlK1Itsgfw/viewform?usp=sf_link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="w-32" src={due_payment_form_qr} alt="" />
              </a>
              <p className="p-1 rounded bg-blue-100">
                পেমেন্ট ক্লিয়ারেন্স ফর্ম
              </p>
            </div> */}
          </div>
        </div>
      </section>

      {/* <ContactInfo></ContactInfo> */}
      {/* <p className="my-3">
        টাকা পাঠানো বা গ্রুপে যুক্ত হওয়া নিয়ে কোন সমস্যা হলে আমাদেরকে
        সাপোর্টে/ফেসবুক পেইজে মেসেজ দিন।
      </p> */}
    </div>
  );
};

export default AqeedahDue;
